export const availableFields = {
  select: "select",
  text: "text",
  phone: "phone",
  email: "email",
  password: "password",
  number: "number",
  textarea: "textarea",
  checkbox: "checkbox",
  image: "image",
  multiselect: "multiselect",
  date: "date",
  conditional: "conditional",
  file: "file",
  radio: "radio",
  money: "money",
  hidden: "hidden",
  dateRange: "dateRange",
  rating: "rating",
} as const;
